<template>
  <v-card
    class="mx-auto"
  >
    <v-card-title>
      <v-btn color="blue" @click="load" class="align-left ml-4 mt-2">
        ΑΝΑΖΗΤΗΣΗ
      </v-btn>

      <v-btn color="pink" @click="goCreateUser" class="align-left ml-2 mt-2">
        ΔΗΜΙΟΥΡΓΙΑ ΧΡΗΣΤΗ
      </v-btn>

      <v-btn color="green" @click="downloadUsers" class="align-left ml-2 mt-2">
        ΚΑΤΕΒΑΣΜΑ
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-data-table dense v-if="!loading"
        :headers="tableHeader"
        :items="tableUsers"
        item-key="id"
        :options.sync="pagination"
        :search="search"
        :custom-filter="filter"
        @click:row="goUserDetails"
      >
        <template v-slot:top>
        <v-text-field
          style="max-width: 400px;"
          outline 
          max=30
          v-model="search"
          label="Αναζήτηση"
          class="mx-4"
        ></v-text-field>
        <!-- <v-text-field
          style="max-width: 400px;"
          v-model="campFilter"
          label="Περιοχές Ευθύνης"
          class="mx-4"
        ></v-text-field> -->    
        <CampPicker style="max-width: 400px" :camps="campFilter" :limit="1" ref="campPicker"/>
    
      </template>

      </v-data-table>

    </v-card-text>

  </v-card>
</template>

<script>
import CampPicker from '@/components/CampPicker.vue'

export default {
  name: 'UserManagement',
  components: {
    CampPicker
  },
  async mounted() {
    if (!this.$store.state.user.isAdmin && this.$store.state.user.isCampMaster) {
      this.campFilter = this.$store.state.user.camps
    }

    await this.load()
  },
  data: () => {
    return {
      search: '',
      loading: false,
      error: "",
      users: [],
      campFilter: [],
      pagination: {
        itemsPerPage: 100
      },
      displayNames: {
        'id': 'Αναγνωριστικό (id)',
        'username': 'Όνομα χρήστη',
        'email': 'Email',
        'camps': 'Περιοχές Ευθύνης',
        'isadmin': 'Διαχειριστής',
        'iscampmaster': 'Διαχειριστής Περιοχών'
      }
    }
  },
  computed: {
    tableHeader() {
      const self = this
      if (!this.users || this.users.length == 0) {
        return []
      }
      return Object.keys(this.users[0])
          .map(function(x){ 
            return {
              text: self.displayNames[x.toLowerCase()],
              align: 'start',
              sortable: true,
              value: x
            }
          }
          )
    },
    tableUsers() {
      return this.users.map(function(x) {
        var c = Object.assign({}, x)
        c.camps = x.camps.join()
        c.isAdmin = x.isAdmin ? 'x' : '-'
        c.isCampMaster = x.isCampMaster ? 'x' : '-'

        return c
      })
    }
  },
  methods: {
    goUserDetails(value) {
      this.$router.push(`/users/${value.id}`)
    },
    goCreateUser() {
      this.$router.push('/users/create')
    },
    async load() {
      this.loading = true
      var q = {};

      const ref_campPicker = this.$refs.campPicker
      if (ref_campPicker.selectedCamps.length > 0) {
        q.camps = this.$refs.campPicker.selectedCamps[0]
      }

      try{
        const response = await this.$axios.get(`/users`, { params: {...q} })
        this.users = response.data
      } catch (e) {
        console.log(e)
        this.error = e 
      }

      this.loading = false
    },
    async downloadUsers () {
      try{
        const response = await this.$axios.get('/users/export')
        const csvContent = "data:text/csv;charset=utf-8," + response.data

        var encodedUri = encodeURI(csvContent)
        
        var link = document.createElement("a")
        link.hidden = true
        link.setAttribute("href", encodedUri)
        link.setAttribute("download", "users.csv")
        document.body.appendChild(link);
        link.click()

      } catch (e) {
        console.log(e.response)
        this.error = e.response.data 
      }
    },
    /* eslint-disable */
    filter (value, search, _item) {  // _item unused var
    /* eslint-enable */
      return value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLowerCase().indexOf(search) !== -1
    },
  }
}
</script>
